export default __webpack_public_path__ + "static/media/proforma-invoice.6f10ea90.hbs";